  // Chakra imports
  import { Box, Grid } from "@chakra-ui/react";

  // Custom components
  import Banner from "views/admin/profile/components/Banner";
  import General from "views/admin/profile/components/General";
  import Notifications from "views/admin/profile/components/Notifications";
  import Projects from "views/admin/profile/components/Projects";
  import Storage from "views/admin/profile/components/Storage";
  import Upload from "views/admin/profile/components/Upload";

  // Assets
  import banner from "assets/img/auth/banner.png";
  import avatar from "assets/img/avatars/photo-dali.png";
  import React from "react";


  export default function Overview() {
    return (
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        {/* Main Fields */}
        <Grid
        mt='10px'
        mb='20px'
          templateColumns={{
            base: "1fr",
            lg: "1.5fr 1.5fr",
          }}
          templateRows={{
            base: "repeat(3, 1fr)",
            lg: "1fr",
          }}
          gap={{ base: "30px", xl: "30px" }}>
          <Storage
            gridArea={{ base: "2 / 1 / 3 / 2", lg: "1 / 2 / 2 / 3" }}
            used={22}
            total={100}
          />
          <Banner
            banner={banner}
            avatar={avatar}
            name='Dali GAMHA'
            job='CEO & Responsable Produit'
            email="dali.gamha@psynarios.com"
            phone="+1234567890"
            calendlyUrl="https://calendly.com/psynarios/15min"
          />
                  
          
        </Grid>
        <Grid
        mt='20px'
        mb='20px'
          templateColumns={{
            base: "1fr",
            lg: "1.5fr 1.5fr",
          }}
          templateRows={{
            base: "repeat(3, 1fr)",
            lg: "1fr",
          }}
          gap={{ base: "30px", xl: "30px" }}>
          <Projects
            gridArea='1 / 2 / 2 / 2'
            banner={banner}
            avatar={avatar}
            name='Adela Parkson'
            job='Product Designer'
            posts='17'
            followers='9.7k'
            following='274'
          />
          <General
            gridArea={{ base: "2 / 1 / 3 / 2", lg: "1 / 2 / 2 / 3" }}
            minH='365px'
            pe='20px'
          />
          </Grid>
          <Grid
        mt='40px'
        mb='20px'
          templateColumns={{
            base: "1fr",
            lg: "1fr 1.5fr",
          }}
          templateRows={{
            base: "repeat(3, 1fr)",
            lg: "1fr",
          }}
          gap={{ base: "30px", xl: "30px" }}>
            
          <Notifications
            minH={{ base: "auto", lg: "420px", "2xl": "365px" }}
            pe='20px'
            pb={{ base: "100px", lg: "10px" }}  
          />
          <Upload
            minH={{ base: "auto", lg: "420px", "2xl": "365px" }}
            pe='20px'
            pb={{ base: "100px", lg: "20px" }}
          />
          
          
        </Grid>
      </Box>
    );
  }
